const getTaskStatusColor = (status_color) => {
  switch (status_color) {
    case "black":
      return "#000000";
    case "red":
      return "#ff0000";
    case "orange":
      return "#ffae00";
    case "blue":
      return "#0089ff";
    default:
      return "#ffffff";
  }
};

export default getTaskStatusColor;
